if (!customElements.get('colour-group-picker')) {
  customElements.define(
    'colour-group-picker',
    class ColourGroupPicker extends HTMLElement {
      connectedCallback() {
        this.labelEl = this.querySelector('[data-colour-label]');
        this.list = this.querySelector('.colour-group-picker__list');
        this.viewport = this.querySelector('.colour-group-picker__viewport');
        this.toggleButton = this.querySelector('.colour-group-picker__toggle');
        this.currentColour = this.labelEl ? this.labelEl.textContent.trim() : '';

        this.onPointerOver = this.onPointerOver.bind(this);
        this.onPointerOut = this.onPointerOut.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onToggle = this.onToggle.bind(this);

        if (this.list) {
          this.list.addEventListener('pointerover', this.onPointerOver);
          this.list.addEventListener('pointerout', this.onPointerOut);
          this.list.addEventListener('focusin', this.onFocusIn);
          this.list.addEventListener('focusout', this.onFocusOut);
        }

        if (this.toggleButton) {
          this.toggleButton.addEventListener('click', this.onToggle);
        }

        this.centerCurrent();
        requestAnimationFrame(() => this.centerCurrent());
      }

      disconnectedCallback() {
        if (this.list) {
          this.list.removeEventListener('pointerover', this.onPointerOver);
          this.list.removeEventListener('pointerout', this.onPointerOut);
          this.list.removeEventListener('focusin', this.onFocusIn);
          this.list.removeEventListener('focusout', this.onFocusOut);
        }

        if (this.toggleButton) {
          this.toggleButton.removeEventListener('click', this.onToggle);
        }
      }

      setLabel(colour) {
        if (this.labelEl && colour) {
          this.labelEl.textContent = colour;
        }
      }

      relatedLink(event) {
        return event.relatedTarget && event.relatedTarget.closest
          ? event.relatedTarget.closest('.colour-group-picker__link')
          : null;
      }

      onPointerOver(event) {
        const link = event.target.closest('.colour-group-picker__link');
        if (link) this.setLabel(link.dataset.colour);
      }

      onPointerOut(event) {
        if (!this.relatedLink(event)) this.setLabel(this.currentColour);
      }

      onFocusIn(event) {
        const link = event.target.closest('.colour-group-picker__link');
        if (link) this.setLabel(link.dataset.colour);
      }

      onFocusOut(event) {
        if (!this.relatedLink(event)) this.setLabel(this.currentColour);
      }

      onToggle() {
        const expanded = this.classList.toggle('is-expanded');
        this.toggleButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        const showAll = this.toggleButton.querySelector('[data-label-show-all]');
        const showLess = this.toggleButton.querySelector('[data-label-show-less]');
        if (showAll) showAll.hidden = expanded;
        if (showLess) showLess.hidden = !expanded;
        if (!expanded) this.centerCurrent();
      }

      centerCurrent() {
        if (!this.list || this.classList.contains('is-expanded') || window.matchMedia('(min-width: 750px)').matches) {
          return;
        }

        const current = this.querySelector('.colour-group-picker__link[aria-current="page"]');
        if (!current) return;

        const item = current.closest('.colour-group-picker__item');
        if (!item) return;

        const scroller = this.viewport || this.list;
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const left = itemCenter - scroller.clientWidth / 2;
        scroller.scrollTo({ left, behavior: 'auto' });
      }
    }
  );
}
